import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { customerApi, useCustomerAuth } from "../lib/customerAuth";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = (location.hash.match(/session_id=([^&]+)/) || [])[1];
    if (!sessionId) {
      navigate("/accedi", { replace: true });
      return;
    }
    customerApi
      .post("/google/session", { sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/area-clienti", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        toast.error("Accesso con Google non riuscito. Riprova.");
        navigate("/accedi", { replace: true });
      });
  }, [location, navigate, setUser]);

  return (
    <div className="pt-[72px] min-h-[70vh] flex items-center justify-center">
      <Loader2 size={28} className="animate-spin text-[#F26522]" />
    </div>
  );
};

export default AuthCallback;
